import {
  defineNuxtRouteMiddleware,
  useNuxtApp,
  type RouteMiddleware
} from 'nuxt/app'

export const handleRouteTracking: RouteMiddleware = (to, from) => {
  const { $mixpanel } = useNuxtApp()
  if (!$mixpanel || !to.name) return
  $mixpanel.trackNavigateEvent({
    NavigateFrom: from.name?.toString() ?? '',
    NavigateTo: to.name.toString()
  })
}

export default defineNuxtRouteMiddleware(handleRouteTracking)
